import React from 'react';
const values = [{
  title: 'Respect',
  desc: 'For ourselves, our instructors, and our community.'
}, {
  title: 'Discipline',
  desc: 'The bridge between goals and accomplishment.'
}, {
  title: 'Perseverance',
  desc: 'The strength to keep going when things get tough.'
}];
export function AboutValues() {
  return <section className="py-20 bg-[#111]" data-id="element-463">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-464">
        <h2 className="text-3xl font-bold text-white mb-16 text-center" data-id="element-465">
          Our Core Values
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-466">
          {values.map((value, index) => <div key={value.title} className="animate-scroll-fade-up bg-[#1a1a1a] p-8 rounded-2xl text-center border border-gray-800 hover:border-[#00D4FF] transition-colors" style={{
          animationDelay: `${index * 0.2}s`
        }} data-id="element-467">
              <h3 className="text-2xl font-bold text-[#00D4FF] mb-4" data-id="element-468">
                {value.title}
              </h3>
              <p className="text-gray-300" data-id="element-469">{value.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}